import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { renderDynamicallyFields } from "../../../../components/Form/methods";
import Button from "../../../../components/Button";
import { useDateFormat } from "../../../../utils/hooks/useDateFormat";
import { prepareFields, saveSectionData } from "./methods";
import { ReportCollapse } from "./ReportCollapse";

export const ReportSectionWrapper = ({
  form,
  type,
  hasError,
  data,
  basicDataSaved,
  fields,
  sectionTitleKey,
  sectionTooltipKey,
  successMessageKey,
  errorMessageKey,
  children
}) => {
  const { t } = useTranslation();
  const { formatLocaleUTC, format } = useDateFormat();
  const [loading, setLoading] = useState(false);

  const saveData = () => {
    const usedData = data?.basic_data?.id ? data : basicDataSaved;
    saveSectionData({
      form,
      data: usedData,
      setLoading,
      formatLocaleUTC,
      format,
      successMessage: t(successMessageKey),
      errorMessage: t(errorMessageKey)
    });
  };

  return (
    <div className={classNames("activity-view-content mb-20", { error: hasError })}>
      <ReportCollapse
        collapsed={false}
        isSectionDisabled={!basicDataSaved?.basic_data}
        header={{
          title: t(sectionTitleKey),
          tooltip: data?.basic_data?.id ? t(sectionTooltipKey) : t("ior.new_report.disabled_feedback")
        }}
      >
        {children || renderDynamicallyFields(prepareFields(type, fields))}
        <div className="flex flex-justify-end mt-15">
          <Button
            className="min-w-110 ant-btn-sm"
            type="primary"
            icon={<i className="ti-check" />}
            onClick={saveData}
            disabled={loading || type === "view"}
            loading={loading}
          >
            {t("container.general_words.save")}
          </Button>
        </div>
      </ReportCollapse>
    </div>
  );
};
